enum MODAL {
  AuthPasswordNew = "modal-auth-password-new",
  AuthPasswordReset = "modal-auth-password-reset",
  AuthRegistration = "modal-auth-registration",
  ContactMigration = "modal-contact-migration",
  ClientProfileDelete = "modal-client-profile-delete",
  FaqArticlesImage = "modal-faq-articles-image",
  HeaderNotification = "modal-header-notification",
  ProjectCreate = "modal-project-create",
  PartnerWithdrawModal = "modal-partner-withdraw",
  Audit = "modal-audit",
}

export { MODAL };
